var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPlayWhite = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 55,
    viewBox: "0 0 54 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 27.5,
    cy: 27.5,
    r: 19.5,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27 0C12.096 0 0 12.32 0 27.5C0 42.68 12.096 55 27 55C41.904 55 54 42.68 54 27.5C54 12.32 41.904 0 27 0ZM20.25 39.875V15.125L39.15 27.5L20.25 39.875Z",
    fill: "#00ddf4"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPlayWhite);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/play_white.02859df63c8ea57c2d582bc004abe1db.svg";